import { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import ReCAPTCHA from 'react-google-recaptcha'

import useAuth from 'hooks/useAuth'
import useSnackbar from 'hooks/useSnackbar'

import { Box, Button } from '@material-ui/core'

import {
  PasswordValidator,
  PasswordInputField,
  LoadingFeedback,
} from 'components'
import { routes } from 'Routes'
import * as service from 'service'
import { getGoogleRecaptchaToken, isSandbox } from 'service/env'
import schemas from '../../schemas'

export const Form = ({ defaultValues }) => {
  const [loading, setLoading] = useState(false)
  const [recaptcha, setRecaptcha] = useState(undefined)
  const [passwordInput, setPasswordInput] = useState('')
  const [justSubmitted, setJustSubmitted] = useState(false)

  const history = useHistory()
  const auth = useAuth()
  const snackbar = useSnackbar()

  const { handleSubmit, errors, control } = useForm({
    validationSchema: schemas.newPassword,
    defaultValues: defaultValues,
  })

  const recaptchaRef = useRef(null)

  const disableSubmitButton = !isSandbox ? !recaptcha || loading : false

  const onSubmit = async (data) => {
    setLoading(true)

    try {
      const response = await service.dponet.user.newPassword({
        ...data,
        recaptcha,
      })

      const login = {
        email: response?.data?.email,
        password: data.password,
      }

      await service.dponet.auth.login(login)

      snackbar.open({
        message: 'Senha alterada com sucesso',
        variant: 'success',
      })

      setTimeout(auth.loadDataWithAnimation, 1000)
    } catch (error) {
      if (!isSandbox) resetRecaptcha()
      history.push(routes.root, {
        error:
          error?.response?.data?.error?.message || 'E-mail ou senha inválidos!',
      })
    }
  }

  const resetRecaptcha = () => {
    recaptchaRef.current.reset()
    setRecaptcha(undefined)
  }

  const handleAcceptedRecaptcha = (recaptchaToken) => {
    setRecaptcha(recaptchaToken)
  }

  const disableRecaptcha = () => setRecaptcha(undefined)

  const handleSubmitForm = (event) => {
    setJustSubmitted(true)
    handleSubmit(onSubmit)(event)
  }

  const handleChangePasswordInput = (e) => {
    setPasswordInput(e.target.value)
  }

  return (
    <>
      <LoadingFeedback open={loading} />
      <Box mb={3}>
        <PasswordValidator
          passwordInput={passwordInput}
          justSubmitted={justSubmitted}
        />
      </Box>
      <form onSubmit={handleSubmitForm}>
        <Controller
          as={
            <PasswordInputField
              label="Nova senha"
              color="primary"
              variant="outlined"
              error={!!errors.password}
              fullWidth
            />
          }
          control={control}
          name="password"
          mode="onChange"
          onChange={([event]) => {
            handleChangePasswordInput(event)
            return event.target.value
          }}
        />
        <Controller
          as={
            <PasswordInputField
              label="Confirme a senha"
              variant="outlined"
              margin="normal"
              error={!!errors.passwordConfirm}
              helperText={errors?.passwordConfirm?.message}
              fullWidth
            />
          }
          control={control}
          name="passwordConfirm"
          mode="onChange"
        />
        <Controller as={<></>} control={control} name="resetPasswordToken" />
        {!isSandbox && (
          <Box
            mt={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <ReCAPTCHA
              ref={recaptchaRef}
              render="explicit"
              sitekey={getGoogleRecaptchaToken()}
              onChange={handleAcceptedRecaptcha}
              onExpired={disableRecaptcha}
            />
          </Box>
        )}
        <Box
          mt={2}
          display="flex"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <Button
            color="primary"
            type="submit"
            variant="contained"
            disabled={disableSubmitButton}
          >
            {loading ? 'Carregando...' : 'Cadastrar nova senha'}
          </Button>
        </Box>
      </form>
    </>
  )
}

export default Form
